import { RostersContainer } from "./styles";
import { useAppSelector } from "app/hooks";
import { selectRosterIdsAlphabetically } from "selectors/Roster";
import { RosterGridItem } from "./RosterGridItem";
import { shallowEqual } from "react-redux";

interface Props {
  rosterIds: string[];
  tournamentId: string;
}

export const RosterGrid = ({ rosterIds, tournamentId }: Props) => {
  const sortedRosterIds = useAppSelector(
    (state) => selectRosterIdsAlphabetically(state, tournamentId, rosterIds),
    shallowEqual
  );
  return (
    <RostersContainer>
      {sortedRosterIds.map((rosterId) => (
        <RosterGridItem
          key={rosterId}
          rosterId={rosterId}
          tournamentId={tournamentId}
        />
      ))}
    </RostersContainer>
  );
};
